"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllGroupMembers = void 0;
const tslib_1 = require("tslib");
const getGroupMembers_1 = require("./getGroupMembers");
const getGroupMemberCount_1 = require("./getGroupMemberCount");
const getAllGroupMembers = options => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
  const {
    chatId,
    env
  } = options;
  const count = yield (0, getGroupMemberCount_1.getGroupMemberCount)({
    chatId,
    env
  });
  const overallCount = count.overallCount;
  const limit = 5000;
  const totalPages = Math.ceil(overallCount / limit);
  const pageNumbers = Array.from({
    length: totalPages
  }, (_, i) => i + 1);
  const groupMembers = [];
  const memberFetchPromises = pageNumbers.map(page => (0, getGroupMembers_1.getGroupMembers)({
    chatId,
    env,
    page,
    limit
  }));
  const membersResults = yield Promise.all(memberFetchPromises);
  membersResults.forEach(result => {
    if (result.length > 0) {
      groupMembers.push(...result);
    }
  });
  return groupMembers;
});
exports.getAllGroupMembers = getAllGroupMembers;
//# sourceMappingURL=getAllGroupMembers.js.map